import { CampaignDetailSlice } from './types';
import { DAY_PASCAL, DURATION_SECONDS } from '../../../constants/common';
import { REDUX_KEY } from '../../constants';

const initialState: CampaignDetailSlice = {
  [REDUX_KEY.AGENCY_NAME]: '',
  [REDUX_KEY.ADVERTISER_NAME]: '',
  [REDUX_KEY.CAMPAIGN_NAME]: '',
  [REDUX_KEY.ADVERTISER_DISCOUNT]: 0,
  [REDUX_KEY.CAMPAIGN_DURATIONS]: {
    [DURATION_SECONDS.FIVE]: false,
    [DURATION_SECONDS.TEN]: false,
    [DURATION_SECONDS.FIFTEEN]: false,
    [DURATION_SECONDS.THIRTY]: false,
    [DURATION_SECONDS.FORTY_FIVE]: false,
    [DURATION_SECONDS.SIXTY]: false,
    [DURATION_SECONDS.NINETY]: false
  },
  [REDUX_KEY.CAMPAIGN_LENGTH]: {
    [REDUX_KEY.CAMPAIGN_LENGTH_START_DATE]: undefined,
    [REDUX_KEY.CAMPAIGN_LENGTH_END_DATE]: undefined
  },
  [REDUX_KEY.CAMPAIGN_NOTES]: '',
  [REDUX_KEY.GROSS_BUDGET]: 0,
  [REDUX_KEY.TARGET_TARP]: 0,
  [REDUX_KEY.TARGET_IMPACT]: 0,
  [REDUX_KEY.DEMOGRAPHIC]: null,
  [REDUX_KEY.USED_BUDGET]: 0,
  [REDUX_KEY.USED_TARPS]: 0,
  [REDUX_KEY.USED_IMPACTS]: 0,
  [REDUX_KEY.SELECTED_MONTH]: undefined,
  [REDUX_KEY.COMMENCING_DAY]: DAY_PASCAL.SUNDAY
};

export default initialState;
